import styled from 'styled-components'
import { GobblersImg } from '../image/Image'
import { ResponsiveSquareContainer, ResponsiveSquareContainerContent } from './ResponsiveSquare'
import { Spacer } from './Spacer'
import { PBoldResponsive, LabelResponsive } from './Typography'
import Zoom from 'react-medium-image-zoom'

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 36px;
  margin: 0 -16px;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    grid-template-columns: repeat(3, 1fr);

    margin: 0 -0px;
  `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: repeat(2, 1fr);
  `}

${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: repeat(1, 1fr);
  `}
`

interface GalleryItemProps {
  imgSrc: string
  title: string | React.ReactNode
  subtitle: string | React.ReactNode
}

const GalleryItem = (props: GalleryItemProps) => {
  return (
    <>
      <ResponsiveSquareContainer borderSize="thin">
        <ResponsiveSquareContainerContent borderSize="thin">
          <Zoom>
            <GobblersImg src={props.imgSrc} />
          </Zoom>
        </ResponsiveSquareContainerContent>
      </ResponsiveSquareContainer>

      <Spacer size={16} />
      <div>
        <PBoldResponsive style={{ fontWeight: 700 }}>{props.title}</PBoldResponsive>
      </div>
      <Spacer size={8} />
      <div>
        <LabelResponsive>{props.subtitle}</LabelResponsive>
      </div>
    </>
  )
}

export { GalleryGrid, GalleryItem }
